// extracted by extract-css-chunks-webpack-plugin
module.exports = {"subtitle":"subtitle___x07P3","submit":"submit___QdMqT"};